import { wrap } from '../labels/wrapLabels';
import { toPrecision } from './commons';

/** Return the max value with an extra margin so that the render is nice. */
const getMaxValue = (min: number, max: number) => {
    const margin = 0.2 * (max - min);
    return toPrecision(max + margin, 2);
};

// The max value for polar bar charts is 1.1 so that the bars are not too close to the border.
const POLAR_BAR_FRACTION_MAX_VALUE = 1.1;

/** Get the Y axis max value formatter.
 * @param {boolean} isPolar - Whether the chart is polar or not.
 * @param {DataTypesT} yType - The type of the Y axis.
 * @param {boolean | undefined}  goalValue - The goal value.
 * @returns  The max value formatter.
 */
export const getYMaxValueFormatter = (
    isPolar: boolean,
    yType: DataTypesT,
    goalValue: number | undefined,
) => {
    if (isPolar && yType === 'fraction') {
        return POLAR_BAR_FRACTION_MAX_VALUE;
    }
    if (isPolar || goalValue) {
        return (value: { min: number; max: number }) =>
            getMaxValue(value.min, Math.max(value.max, goalValue ?? 0));
    }
    return undefined;
};

export const getYAxisNameGap = (
    areTicksRotated: boolean | undefined,
    isHorizontal: boolean,
) => {
    if (areTicksRotated && isHorizontal) {
        return 50;
    }
    if (isHorizontal) {
        return 20;
    }
    return 15;
};

export const wrapYAxisName = (name: string) => {
    // we use a magic number to force to wrap in most cases, because taking
    // the widget width is not reliable enough without changing the shared logic
    // of "wrap" helper.
    const AXIS_MAGIC_WIDTH = 400;
    const NAME_WRAP_FACTOR = 30;
    return wrap(name, AXIS_MAGIC_WIDTH, NAME_WRAP_FACTOR, 3);
};
